/**
 * DevExtreme (esm/__internal/ui/date_box/m_date_box.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../../core/component_registrator";
import DateBoxMask from "./m_date_box.mask";
registerComponent("dxDateBox", DateBoxMask);
export default DateBoxMask;
